<template>
    <v-app>
        <!-- <mainMenu></mainMenu> -->
        <v-container fluid fill-height loginOverlay>
            <v-layout flex align-center justify-center>
                <v-flex xs12 sm4 elevation-6>
                    <v-toolbar class="orange accent-3">
                        <v-toolbar-title class="white--text">
                            <font size="5">
                                <v-icon dark large>mdi-bus</v-icon>
                                Delivery Kiosk
                            </font>
                            <!-- {{$store.state.user}} -->
                            <!-- {{user}} -->
                            <!-- {{user2}} -->
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card>
                        <v-card-text pt-4>
                            <v-form>
                                <v-text-field label="รหัสผู้ใช้ หรือ อีเมล" ref="focusUser" v-model="email" :rules="emailRules" required
                                    autocapitalize="off" autocorrect="off" spellcheck="false"
                                    @keypress.enter="login" color="orange accent-3">
                                </v-text-field>
                                <v-text-field label="Password:" v-model="password" :type="hidePass ? 'password' : 'text'"
                                :append-icon="hidePass ? 'mdi-eye' : 'mdi-eye-off'" @click:append="hidePass = !hidePass"
                                :rules="passwordRules" required @keypress.enter="login" ref="focusPass" color="orange accent-3">
                                </v-text-field>
                                <v-layout justify-end>
                                    <!-- <a href="">Sign up</a> -->
                                    <a @click="showReset"><font color="orange">ลืมรหัสผ่าน?</font></a>
                                </v-layout>
                                <v-layout>
                                    <v-btn @click="login" color="orange accent-4" dark>เข้าสู่ระบบ</v-btn>
                                </v-layout>
                            </v-form>

                            <!-- Dialog รีเซ็ทรหัสผ่าน -->
                            <v-dialog v-model="showRePass" persistent max-width="500px">
                                <v-card>
                                    <v-card-title>รีเซ็ทรหัสผ่าน</v-card-title>
                                    <v-card-text>
                                        <v-container>
                                            <v-flex>
                                                <v-text-field label="อีเมล:" ref="focusEmail" color="orange accent-4"
                                                v-model="resetPass" :rules="emailRules"
                                                required @keypress.enter="sendEmail">
                                                </v-text-field>
                                            </v-flex>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn text @click="cancelResetPass">ย้อนกลับ</v-btn>
                                        <v-btn text color="green accent-4" @click="sendEmail" dark>ยืนยัน</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <!-- Dialog progress -->
        <v-dialog v-model="showDialogProgress" max-width="80" persistent>
            <div class="text-center">
                <v-card>
                    <v-card-text>
                        <v-progress-circular :size="30" color="orange accent-5" indeterminate></v-progress-circular>
                    </v-card-text>
                </v-card>
            </div>
        </v-dialog>

        <!-- Dialog Success -->
        <v-dialog v-model="showDialogSuccess" max-width="260" persistent>
            <div class="text-center">
                <v-card>
                    <v-card-text>
                        <v-layout>
                            <v-flex>
                                <v-icon color="green" :size="45">mdi-check-circle-outline</v-icon>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                สำเร็จ!
                                <!-- สำเร็จ! กรุณาตรวจสอบกล่องข้อความอีเมล์ของคุณ -->
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                โปรดตรวจสอบข้อความในอีเมล์ของคุณ
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </div>
        </v-dialog>

        <!-- Dialog Error -->
        <v-dialog v-model="showDialogError" :max-width="msgError.length*7">
            <div class="text-center">
                <v-card>
                    <v-card-text>
                        <v-layout>
                            <v-flex>
                                <v-icon color="red" :size="45">mdi-close-circle-outline</v-icon>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                {{msgError}}
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </div>
        </v-dialog>

    </v-app>
</template>
<script>
import {auth} from '@/firebase'
export default {
    data(){
        return{
            showDialogProgress: false,
            showDialogSuccess: false,
            showDialogError: false,
            msgError: '',
            hidePass: true,
            showRePass: false,
            email: '',
            password: '',
            resetPass: '',
            emailRules: [
              v => !!v || 'กรุณากรอกรหัสผู้ใช้หรืออีเมล',
            //   v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'กรุณากรอกอีเมล์ให้ถูกต้อง'
            ],
            passwordRules: [
                (v) => !!v || 'กรุณากรอกรหัสผ่านของท่าน',
            ],
            isNavigating: false,
            unsubscribeAuth: null
        }
    },
    methods:{
        // A bare name is a user ID first (userProfile.js: <id>@users.delivery-kiosk.local)
        // and the old @kioskthailand.com shortcut second, so everyone who typed
        // just their name before still gets in. We try every candidate address
        // and stop early only on an error that no other address could fix
        // (lockout, offline, or the account itself being disabled); any other
        // code -- including a wrong-credential answer, whatever shape it takes --
        // moves on to the next candidate. This is deliberately inverted from a
        // whitelist of "retry on these": the pinned SDK (@firebase/auth 0.12.0)
        // cannot return `auth/invalid-login-credentials`, and with
        // email-enumeration protection a wrong password or unknown address can
        // surface as a code we didn't anticipate, so an allowlist would strand
        // an unconverted staff member's bare name at the first address it
        // doesn't match. The field is left as typed -- rewriting it on screen
        // would show a user-ID account an address it does not have.
        async login(){
            if(!this.$refs.focusUser.validate()){
                this.$refs.focusUser.focus()
                return
            }
            if(!this.$refs.focusPass.validate()){
                this.$refs.focusPass.focus()
                return
            }
            const typed = String(this.email || '').trim().toLowerCase()
            const candidates = typed.includes('@')
                ? [typed]
                : [typed + '@users.delivery-kiosk.local', typed + '@kioskthailand.com']
            const final = ['auth/too-many-requests', 'auth/network-request-failed', 'auth/user-disabled']
            for (let i = 0; i < candidates.length; i++) {
                try {
                    await auth.signInWithEmailAndPassword(candidates[i], this.password)
                    return
                } catch (e) {
                    if (final.indexOf(e && e.code) !== -1) break
                }
            }
            this.msgError = 'รหัสผู้ใช้/อีเมล หรือรหัสผ่านไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง'
            this.showDialogError = true
            setTimeout(() => {
                this.showDialogError = false
            }, 4000)
        },
        showReset(){
            this.showRePass = true
            this.$nextTick(()=>this.$refs.focusEmail.focus())
        },
        cancelResetPass(){
            this.showRePass = false
            this.resetPass = ''
            this.email = ''
            this.password = ''
            this.$nextTick(()=>{this.$refs.focusUser.focus()})
        },
        sendEmail(){
            // A user-ID account's address is not an inbox; a reset email would
            // go nowhere and look like it worked.
            const typed = String(this.resetPass || '').trim().toLowerCase()
            if (typed && (!typed.includes('@') || typed.endsWith('@users.delivery-kiosk.local'))) {
                this.msgError = 'บัญชีที่ใช้รหัสผู้ใช้ กรุณาติดต่อผู้ดูแลระบบเพื่อรีเซ็ตรหัสผ่าน'
                this.showDialogError = true
                return
            }
            if(!this.$refs.focusEmail.validate()){
                this.$refs.focusEmail.focus()
            }
            else{
                this.showDialogProgress = true
                auth.sendPasswordResetEmail(this.resetPass)
                .then(()=>{
                    this.showDialogProgress = false
                    this.showDialogSuccess = true
                    setTimeout(() => {
                        this.showDialogSuccess = false
                        this.cancelResetPass()
                    }, 2000)
                })
                .catch(()=>{
                    this.msgError = 'ไม่พบอีเมล์นี้ในระบบ กรุณาลองใหม่อีกครั้ง'
                    this.showDialogProgress = false
                    this.showDialogError = true
                    setTimeout(() => {
                        this.showDialogError = false
                        this.$nextTick(()=>this.$refs.focusEmail.focus())
                    }, 4000)
                })
            }
        }

    },
    computed:{
        user(){
            return this.$store.state.user
        },
        user2(){
            return sessionStorage.user
        }
    },
    mounted(){
        // this.unsubscribeAuth = auth.onAuthStateChanged(user=> {
        //     if(user){
        //         user.getIdTokenResult().then(idTokenResult =>{
        //             // if(idTokenResult.claims.status == 'administrator'){
        //             //     this.$store.commit('setAdministrator')
        //             //     sessionStorage.status = 'administrator'
        //             // }
        //             // else if(idTokenResult.claims.status == 'admin'){
        //             //     this.$store.commit('setAdmin')
        //             //     sessionStorage.status = 'admin'
        //             // }
        //             // else if(idTokenResult.claims.status == 'delivery'){
        //             //     this.$store.commit('setDelivery')
        //             //     sessionStorage.status = 'delivery'
        //             // }
        //             // const validRoles = ['administrator', 'admin', 'delivery'];
        //             const userStatus = idTokenResult.claims.status;
                    
        //             // if (userStatus && validRoles.includes(userStatus)) {
        //             if (userStatus) {
        //                 this.$store.commit('setRole', userStatus);
        //                 sessionStorage.status = userStatus;
        //             } else {
        //                 this.$store.commit('clearUser');
        //                 sessionStorage.status = 'user';
        //             }
        //         })
        //         this.$store.commit('setUser',user.email)
        //         sessionStorage.user = user.email
        //         this.$router.currentRoute.name !== 'index' && this.$router.push({ name: 'index' })
                
        //     }
        //     else{
        //         this.$store.commit('clearRole')
        //         sessionStorage.user = 'null'
        //         sessionStorage.status = 'null'
        //     }
        // })
        
        this.$nextTick(()=>{this.$refs.focusUser.focus()})
    },
    beforeDestroy() {
        if (this.unsubscribeAuth) {
            this.unsubscribeAuth();
        }
    },
}
</script>